import script from "./CardReservaPlazasLibres.vue?vue&type=script&setup=true&lang=js"
export * from "./CardReservaPlazasLibres.vue?vue&type=script&setup=true&lang=js"

import "./CardReservaPlazasLibres.vue?vue&type=style&index=0&id=437588db&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437588db"]])

export default __exports__